import React from 'react';
import Lottie from 'lottie-react';

/* ═══════════════════════════════════════════════════════════════
   LIVE PULSE — a tiny, self-contained Lottie animation used
   anywhere the dashboard needs to signal "this is live / updating"
   (topbar refresh timestamp, Active Orders badge).

   It's defined inline (no external file/CDN fetch) so it drops in
   with zero asset-hosting setup — just `npm i lottie-react`.
   To use a richer icon pack instead, export JSON from LottieFiles
   or Lordicon and swap the `pulseAnim` object below.
═══════════════════════════════════════════════════════════════ */
const pulseAnim = {
  v: '5.7.4', fr: 30, ip: 0, op: 60, w: 40, h: 40, nm: 'pulse', ddd: 0,
  assets: [],
  layers: [
    {
      ty: 4, nm: 'ring', ks: {
        o: { a: 1, k: [{ t: 0, s: [60] }, { t: 30, s: [0] }, { t: 60, s: [60] }] },
        p: { a: 0, k: [20, 20, 0] },
        s: { a: 1, k: [{ t: 0, s: [40, 40, 100] }, { t: 30, s: [220, 220, 100] }, { t: 60, s: [40, 40, 100] }] },
        r: { a: 0, k: 0 }, a: { a: 0, k: [0, 0, 0] },
      },
      shapes: [{
        ty: 'gr', it: [
          { ty: 'el', p: { a: 0, k: [0, 0] }, s: { a: 0, k: [16, 16] } },
          { ty: 'fl', c: { a: 0, k: [0.06, 0.72, 0.51, 1] }, o: { a: 0, k: 100 } },
        ],
      }],
      ip: 0, op: 60, st: 0,
    },
    {
      ty: 4, nm: 'core', ks: {
        p: { a: 0, k: [20, 20, 0] }, s: { a: 0, k: [100, 100, 100] }, r: { a: 0, k: 0 }, a: { a: 0, k: [0, 0, 0] },
      },
      shapes: [{
        ty: 'gr', it: [
          { ty: 'el', p: { a: 0, k: [0, 0] }, s: { a: 0, k: [14, 14] } },
          { ty: 'fl', c: { a: 0, k: [0.06, 0.72, 0.51, 1] }, o: { a: 0, k: 100 } },
        ],
      }],
      ip: 0, op: 60, st: 0,
    },
  ],
};

const LivePulse = ({ size = 14 }) => (
  <span style={{ width: size, height: size, display: 'inline-flex', flexShrink: 0 }}>
    <Lottie animationData={pulseAnim} loop autoplay style={{ width: size, height: size }} />
  </span>
);

export default LivePulse;